import { useState } from "react";
import CreateTimeslot from "./createTimeslot";
import ViewTimeslot from "./viewTimeslot";
import PopUpViewPrenotationByTimeslot from "../../popUpViewPrenotationByTimeslot";
import { useAppDispatch } from "../../../redux";
import { forceTimeslotDetailUpdate } from "../../../redux/reducer/timeslotReducer";

const PopUpManagerTimeslot = (props: any) => {
  let show = props.show ?? false;
  let showComponent = props.showComponent ?? "";
  let dateSelect = props.dateSelect ?? new Date();
  let timeslotAvailabilityDate = props.timeslotAvailabilityDate ?? null;
  let idEvent = props.idEvent ?? "";

  const [selectedDay, setSelectedDay] = useState("");
  const [selectedTimeslot, setSelectedTimeslot] = useState("");
  const [selectedBookingId, setSelectedBookingId] = useState("");
  const [showPopUpViewPrenotationByTimeslot, setShowPopUpViewPrenotationByTimeslot] = useState(false);

  const dispatch = useAppDispatch();

  const clickPrenotationLink = (day: string, timeslotId: string, bookingId: string) => {
    console.log('popUpManagerTimeslot clickPrenotationLink', day, timeslotId, bookingId)
    setSelectedDay(day);
    setSelectedTimeslot(timeslotId);
    setSelectedBookingId(bookingId);

    setShowPopUpViewPrenotationByTimeslot(true)
  }

  const onPopUpViewPrenotationClose = () => {
    setShowPopUpViewPrenotationByTimeslot(false)
    dispatch(forceTimeslotDetailUpdate());
  }

  return (
    <>
      <div className={`PopUpManagerTimeslot ${((show) ? 'active' : '')}`}>
        {((showComponent === "CreateTimeslot") ?
          <CreateTimeslot date={dateSelect} timeslotAvailabilityDate={timeslotAvailabilityDate} closePopUp={props.closePopUp} />
          :
          <></>)}
        {((showComponent === "ViewTimeslot") ?
          <ViewTimeslot clickPrenotationLink={clickPrenotationLink} idEvent={idEvent} closePopUp={props.closePopUp} />
          :
          <></>)}
      </div>

      {showPopUpViewPrenotationByTimeslot && <PopUpViewPrenotationByTimeslot
        selectedDay={selectedDay}
        selectedTimeslotId={selectedTimeslot}
        selectedBookingId={selectedBookingId}
        closePopUp={onPopUpViewPrenotationClose}
      />}
    </>

  )
}

export default PopUpManagerTimeslot